import { create } from "zustand";

import {
	SAL2100_R01BrandDto,
	SAL2100_R01ItemGroupDto,
	SAL2100_R01MonthlyDto,
} from "./Dto_SAL2100_R01";

export interface SAL2100_R01Filter {
	compCd: string;
	year: number;
	customCd: string;
	customNm: string;
	brandCd: string;
	itemCd: string;
	itemNm: string;
}

export interface Store_SAL2100_R01 {
	SAL2100_R01Filter: SAL2100_R01Filter;
	SAL2100_R01PastFilter: SAL2100_R01Filter;
	SAL2100_R01MonthlyList: SAL2100_R01MonthlyDto[];
	SAL2100_R01ItemGroupList: SAL2100_R01ItemGroupDto[];
	SAL2100_R01BrandList: SAL2100_R01BrandDto[];
	setSAL2100_R01Filter: (filter: Partial<SAL2100_R01Filter>) => void;
	setSAL2100_R01PastFilter: (filter: SAL2100_R01Filter) => void;
	setSAL2100_R01MonthlyList: (list: SAL2100_R01MonthlyDto[]) => void;
	setSAL2100_R01ItemGroupList: (list: SAL2100_R01ItemGroupDto[]) => void;
	setSAL2100_R01BrandList: (list: SAL2100_R01BrandDto[]) => void;
	initData: () => void;
}

export const defaultSAL2100_R01Filter: SAL2100_R01Filter = {
	compCd: "",
	year: new Date().getFullYear(),
	customCd: "",
	customNm: "",
	brandCd: "",
	itemCd: "",
	itemNm: "",
};

export const useSAL2100_R01Store = create<Store_SAL2100_R01>((set) => ({
	SAL2100_R01Filter: { ...defaultSAL2100_R01Filter },
	SAL2100_R01PastFilter: { ...defaultSAL2100_R01Filter },
	SAL2100_R01MonthlyList: [],
	SAL2100_R01ItemGroupList: [],
	SAL2100_R01BrandList: [],
	setSAL2100_R01Filter: (filter) => set((state) => ({
		SAL2100_R01Filter: { ...state.SAL2100_R01Filter, ...filter },
	})),
	setSAL2100_R01PastFilter: (filter) => set({ SAL2100_R01PastFilter: { ...filter } }),
	setSAL2100_R01MonthlyList: (list) => set({ SAL2100_R01MonthlyList: list }),
	setSAL2100_R01ItemGroupList: (list) => set({ SAL2100_R01ItemGroupList: list }),
	setSAL2100_R01BrandList: (list) => set({ SAL2100_R01BrandList: list }),
	initData: () => set({
		SAL2100_R01Filter: { ...defaultSAL2100_R01Filter },
		SAL2100_R01PastFilter: { ...defaultSAL2100_R01Filter },
		SAL2100_R01MonthlyList: [],
		SAL2100_R01ItemGroupList: [],
		SAL2100_R01BrandList: [],
	}),
}));
